// src/styles/modalStyles.js
export const createModalOverrides = (width = 'auto', palette) => ({
  Dialog: {
    style: ({ $theme }) => ({
      width: width,
      maxWidth: '90vw',
      maxHeight: '95vh',
      outline: `1px solid ${palette.borderOpaque}`,
      boxShadow: $theme.lighting.shadow600,
      overflowY: 'auto',
      backgroundColor: palette.backgroundSecondary,
    }),
  },
});

